// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#666","menuActiveText":"#000","subMenuActiveText":"#000","menuBg":"#f5f5f5","menuHover":"#eee","subMenuBg":"#f5f5f5","subMenuHover":"#eee","sideBarWidth":"300px"};